import React, { useState } from 'react'
import { Property } from '../../../../types/Property/Property'
import Card from '../../../Card'
import { classNames } from '../../../../lib/utils/classNames'
import Countdown from '../../Countdown'
import { useTranslation } from 'next-i18next'

type FinancingCountdownCardProps = {
  className?: string
  property: Property
  onCountdownComplete: (countdownComplete: boolean) => void
}

export default function FinancingCountdownCard({
  property,
  className = '',
  onCountdownComplete,
}: FinancingCountdownCardProps) {
  const { t } = useTranslation('originals/property')

  const [countdownComplete, setCountdownComplete] = useState(false)

  const targetDateTime = new Date(property.fundingStartAt)
  const nowDate = new Date()

  const handleOnCountdownComplete = (countdownComplete: boolean) => {
    setCountdownComplete(countdownComplete)
    onCountdownComplete(countdownComplete)
  }

  return (
    <Card className={classNames(className, 'bg-neutralWhite p-3')}>
      {countdownComplete || targetDateTime < nowDate ? (
        <>
          {property.fundingStatus === 'funding' ? (
            <div className="text-center font-bold text-neutralBlack">
              {t('financingCountdownCard.financingAvailableNow')}
            </div>
          ) : (
            <div className="text-center font-bold text-neutralBlack">
              {t('financingCountdownCard.financingAvailableSoon')}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="text-center font-bold text-neutralBlack">
            {t('financingCountdownCard.financingAvailableIn')}
          </div>
          <div className="flex items-center">
            <Countdown
              targetDate={property.fundingStartAt}
              onCountdownComplete={handleOnCountdownComplete}
              className="w-full scale-[0.6] text-neutralBlack"
            />
          </div>
        </>
      )}
    </Card>
  )
}
